<template>
  <div>
    <el-form-item :label="labelText(zdItem.label)">
      <div
        v-for="(item, index) in zdFormattedValue"
        :key="index"
        class="custom-field"
      >
        <el-row>
          <el-col :span="6">
            <el-input
              :value="item.fields"
              @input="updateItemField(index, 'fields', $event)"
              :disabled="viewDisabled || getAuthShow()"
              :placeholder="$t('view.placeholder')"
              :class="{ 'question-mark-highlight': hasQuestionMarkInField(item.fields) }"
            ></el-input>
          </el-col>

          <el-col :span="14" :offset="1">
            <el-input
              :value="item.value"
              @input="updateItemField(index, 'value', $event)"
              :disabled="viewDisabled || getAuthShow()"
              :placeholder="$t('view.placeholder')"
              :class="{ 'question-mark-highlight': hasQuestionMarkInField(item.value) }"
            ></el-input>
          </el-col>
          <!-- 右侧列显示添加和删除按钮 -->
          <el-col :span="3">
            <el-button
              type="primary"
              icon="el-icon-circle-plus"
              circle
              :disabled="viewDisabled || getAuthShow()"
              @click="addClick"
            ></el-button>
            <el-button
              type="danger"
              :disabled="viewDisabled || getAuthShow()"
              icon="el-icon-delete"
              circle
              @click="removeClick(index)"
            ></el-button>
          </el-col>
        </el-row>
      </div>
    </el-form-item>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import base from "@/common/base.js";
export default {
  name: "ZDCustomInput", // 设置组件名称为 ZDCustomInput
  props: {
    zdId: {
      type: String,
      required: true,
    },
    pageStatus: {
      type: String,
      default: "Add",
    },
  },
  computed: {
    // 从 Vuex 获取当前组件的整个状态
    ...mapGetters("zdInput", {
      zdGetComponentState: "getComponentState",
    }),
    // 获取当前组件的状态对象
    zdComponentState() {
      return this.zdGetComponentState(this.zdId);
    },
    // 从状态对象中获取各个字段
    zdItem() {
      return this.zdComponentState;
    },
    labelText() {
      return (label) => {
        let key = "content." + label;
        key = key.toLowerCase().replaceAll(" ", "_");
        return this.$t(key);
      };
    },
    viewDisabled(){
      const pageStatus = this.pageStatus;
      
      // 如果页面状态是Detail，所有字段都不可编辑
      if (pageStatus === "Detail") {
        return true;
      }
      
      // 返回字段本身的disabled配置
      return this.zdItem.disabled || false;
    },
    zdFormattedValue: {
      get() {
        // 确保返回的是数组格式，如果为空则返回默认结构
        if (!Array.isArray(this.zdItem.value) || this.zdItem.value.length === 0) {
          return [{
            fields: "",
            value: "",
            specification: "",
            test_method: "",
          }];
        }
        return this.zdItem.value;
      },
      set(value) {
        this.zdUpdateComponent({
          id: this.zdId,
          field: "value",
          value: value,
        }); // 更新输入框的值
      },
    },
  },
  created() {
    // 组件创建时初始化数据
    this.initValue();
    // 监听页面状态变化
    this.$EventBus.$on("pageStatusChange", this.handlePageStatusChange);
    this.$EventBus.$on("tabChanged", this.handleTabChanged);
  },
  
  beforeDestroy() {
    // 清理事件监听器
    this.$EventBus.$off("pageStatusChange", this.handlePageStatusChange);
    this.$EventBus.$off("tabChanged", this.handleTabChanged);
  },
  methods: {
    // 映射 Vuex 的动作
    ...mapActions("zdInput", ["updateComponent"]),
    zdUpdateComponent(payload) {
      this.updateComponent(payload); // 更新组件状态
    },
    getAuthShow(){
      return base.getAuthShow();
    },
    // 更新指定索引和字段的值
    updateItemField(index, field, value) {
      const newValue = [...this.zdFormattedValue];
      newValue[index] = {
        ...newValue[index],
        [field]: value
      };
      this.zdFormattedValue = newValue;
    },
    // 初始化数据
    initValue(){
      if (!Array.isArray(this.zdItem.value) || this.zdItem.value.length === 0) {
        this.zdUpdateComponent({
          id: this.zdId,
          field: "value",
          value: [{
            fields: "",
            value: "",
            specification: "",
            test_method: "",
          }]
        });
      }
    },
    // 添加新行
    addClick() {
      const newValue = [...this.zdFormattedValue, {
        fields: "",
        value: "",
        specification: "",
        test_method: "",
      }];
      this.zdFormattedValue = newValue;
    },
    // 删除指定行
    removeClick(index) {
      if (this.zdFormattedValue.length > 1) {
        const newValue = this.zdFormattedValue.filter((_, i) => i !== index);
        this.zdFormattedValue = newValue;
      }
    },
    
    /**
     * 处理页面状态变化
     */
    handlePageStatusChange() {
      // console.info("ZDCustomInput: Page status changed to", pageStatus, "for component", this.zdId);
      
      // 强制组件重新计算disabled状态
      this.$forceUpdate();
    },
    
    /**
     * 处理标签页变化
     */
    handleTabChanged() {
      // console.info("ZDCustomInput: Tab changed to", data.tabName, "with status", data.pageStatus, "for component", this.zdId);
      
      // 强制组件重新计算disabled状态
      this.$forceUpdate();
    },
    // 检测单个字段是否包含问号
    hasQuestionMarkInField(fieldValue) {
      if (!fieldValue) return false;
      return fieldValue.includes('?') || fieldValue.includes('？');
    },
  },
};
</script>
<style src="./input-highlight.css" scoped></style>
